module.exports = __webpack_public_path__ + "static/img/erweima.0d38cd12.png";